<template>
  <div>
    <!-- :btnCreate="true" -->
    <PageTitle
      title="Room Types"
      :btnCreate="true"
      :createPopup="true"
      @onClickCreate="createRoomType()"
      :permission="'Room Type Index'"
    />
    <v-container fluid class="lighten-12 container">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="['search']"
          v-model="filter"
          :columns="columns"
        ></TableFilters>
      </v-card>
      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <ValidationObserver ref="observer">
            <v-row>
              <v-card-text class="pa-0">
                <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :headers="headers"
                  :items="roomTypeList"
                  class="row-pointer"
                  hide-default-footer
                  item-class="test2"
                >
                  <template v-slot:item.adult="{ item }">
                    {{ item.base_adult }}/ {{ item.max_adult }}
                  </template>
                  <template v-slot:item.child="{ item }">
                    {{ item.base_child }}/ {{ item.max_child }}
                  </template>

                  <template v-slot:no-data>
                    <div class="mt-16 container justify-center item-center">
                      <noData name="Order" />
                    </div>
                  </template>

                     <template v-slot:item.color="{ item }">
                    <v-chip
                      :x-small="true"
                      class="ma-2"
                      label
                      :text-color="item.color"
                      :color="item.color"
                      dark
                      >  |</v-chip
                    >
                  </template>

                  <template v-slot:item.reference_number="{ item }">
                    <CopyTableCell
                      :text="item.reference_number"
                    ></CopyTableCell>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.status)"
                      dark
                      >{{ item.status }}</v-chip
                    >
                  </template>
                  <template v-slot:item.action="{ item }">
                    <list-menu
                      feature="room-type"
                      :item="item"
                      editPermission="Room Type Edit"
                    DeletePermission="Room Type Edit"

                      @refreshList="refreshData"
                      @onEditClicked="editRoomType(item)"
                      :isEditModal="true"
                    ></list-menu>
                  </template>
                  <template v-slot:footer>
                    <pagination
                      @paginationOptions="setPaginationOptions"
                      @response="receiveRoomTypes"
                      url="hms/room-types"
                      :filter="filter"
                      ref="pagination"
                    />
                  </template>
                </v-data-table>
              </v-card-text>
            </v-row>
          </ValidationObserver>
        </v-container>
      </v-card>
    </v-container>
    <ChequeDetails ref="refChequeDetails" @onClose="onClose" />
    <RoomTypeCreate
      @conform="conform()"
      @afterSave="refreshData()"
      ref="refcreateRoomType"
    />

    <RoomTypeEdit
      @close="AddWarehouse($event)"
      @conform="conform()"
      @afterSave="refreshData()"
      ref="refEditRoomType"
    />
  </div>
</template>
<script>
import noData from "@/components/shared/noItem";
import TableFilters from "@/components/base/TableFilters";
import pagination from "../../shared/components/pagination";
import RoomTypeCreate from "./RoomTypeCreate.vue";
import RoomTypeEdit from "./RoomTypeEdit.vue";
import RoomTypeDetails from "./RoomTypeDetails.vue";
import axios from "@/plugins/axios";

export default {
  data: () => ({
    paginationOptions: {},
    columns: [
      {
        text: "Name",
        value: "name",
        show: true,
        disabled: false,
        width: "10%",
      },
      {
        text: "Code",
        value: "code",
        show: true,
        disabled: true,
        width: "10%",
      },
      {
        text: "Adaults (B/M)",
        value: "adult",
        show: true,
        disabled: true,
        align: "center",
        width: "8%",
      },
      {
        text: "Child (B/M)",
        value: "child",
        show: true,
        disabled: true,
        align: "center",
        width: "10%",
      },
      {
        text: "Color",
        value: "color",
        show: true,
        disabled: true,
        align: "center",
        width: "10%",
      },
      // {
      //   text: "Status",
      //   value: "status",
      //   show: true,
      //   disabled: true,
      //   width: "5%",
      // },
      {
        text: "Action",
        value: "action",
        show: true,
        disabled: true,
        align: "center",
        width: "10%",
      },
    ],
    roomTypeList: [],
    filter: {
      invoice_status: "",
      start: "",
      end: "",
      amount: "",
      supplier: "",
      search: "",
      status: "",
    },
  
  }),
  components: {
    pagination,
    noData,
    TableFilters,
    RoomTypeCreate,
    RoomTypeEdit,
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },

  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },
    onClose() {
      this.$refs.pagination.refreshData();
    },
     refreshData() {
      this.$refs.pagination.refreshData();
    },
    receiveRoomTypes(data) {
      this.roomTypeList = data;
    },
    viewCheque(chequeId) {
      this.$refs.refChequeDetails.openModal(chequeId);
    },
    createRoomType() {
      this.$refs.refcreateRoomType.openModal();
    },
    editRoomType(cheque) {
      
      this.$refs.refEditRoomType.openModal(cheque.id);
    },
    conform() {
      this.$refs.pagination.fetchData();
    },
    getDateValidation(d) {
      var date = new Date(d);
      date.setDate(date.getDate() - 1);

      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      // Add a day
      // date.setDate(date.getDate() + 1)

      let yesterDay = new Date();
      yesterDay.setHours(0);
      yesterDay.setMinutes(0);
      yesterDay.setSeconds(0);

      console.log(date);
      console.log(yesterDay);
      if (date.getTime() <= yesterDay.getTime()) {
        return true;
      } else {
        return false;
      }
    },

    getStatusColor(status) {
      
      switch (status) {
        case "Completed":
          return "green";
          break;
        case "Pending":
          return "orange";
          break;
        case "Canceled":
          return "red";
          break;
        case "Bounced":
          return "red";
          break;
        default:
          break;
      }
    },
  },
  watch: {},
  filters: {},
};
</script>




